module.exports = __webpack_public_path__ + "img/lang-it.0ada57c4.svg";